import React from "react";
import logo from "../resourcess/Products/SRC Logo.svg";

const Navbar = () => {
  return (
    <header className="navbar">
      <div className="navbar-inner">
        <a href="#hero" className="nav-logo">
          <img src={logo} alt="SRC Corporation" />
        </a>
        <nav className="nav-menu">
          <ul className="nav-links">
            <li>
              <a href="#hero" className="nav-link">
                Home
              </a>
            </li>
            <li>
              <a href="#about" className="nav-link">
                About
              </a>
            </li>
            <li>
              <a href="#products" className="nav-link">
                Products
              </a>
            </li>
            <li>
              <a href="#process" className="nav-link">
                Process
              </a>
            </li>
          </ul>
          <a href="#contact" className="nav-contact-btn">
            Contact
          </a>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;